import {
  Award,
  Bell,
  CalendarCheck,
  CheckCircle2,
  Settings,
  Swords,
  Trophy,
  TrendingUp,
  UserPlus,
  type LucideIcon,
} from "lucide-react";
import type { FeedEvent, FeedEventType } from "@/modules/leagues/types/feed";

const ICONS: Record<FeedEventType, LucideIcon> = {
  participant_joined: UserPlus,
  settings_changed: Settings,
  invite_accepted: CheckCircle2,
  round_released: CalendarCheck,
  matches_finished: Bell,
  score_updated: TrendingUp,
  bonus_added: Award,
  challenge_created: Swords,
  duel_accepted: Swords,
  duel_resolved: Trophy,
  round_mvp: Trophy,
};

function formatRelative(iso: string): string {
  const diffMs = Date.now() - new Date(iso).getTime();
  const diffH = Math.round(diffMs / (60 * 60 * 1000));
  if (diffH < 1) return "agora há pouco";
  if (diffH < 24) return `há ${diffH}h`;
  const diffD = Math.round(diffH / 24);
  return `há ${diffD}d`;
}

export function FeedItem({ event }: { event: FeedEvent }) {
  const Icon = ICONS[event.type];
  return (
    <div className="flex items-start gap-3 rounded-xl border border-border bg-card p-3">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-600 dark:bg-primary-900/40 dark:text-primary-300">
        <Icon className="h-4 w-4" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm">{event.message}</p>
        <p className="mt-0.5 text-[11px] text-muted-foreground">{formatRelative(event.createdAt)}</p>
      </div>
    </div>
  );
}
